import {Area} from '../enums/Area.js';
import {BooleanName} from '../enums/BooleanName.js';
import {GameModeType} from '../enums/GameModeType.js';

/**
 * Generic place to check if something is implemented
 * If something gets implemented, it should be added here too so the game can check
 */
export class ImplementationManager {
    private static _instance: ImplementationManager;
    static get instance(): ImplementationManager {
        if (!ImplementationManager._instance) {
            ImplementationManager._instance = new ImplementationManager();
        }
        return ImplementationManager._instance;
    }

    private _implementedGameModes = [
        GameModeType.Quickplay,
        GameModeType.Easy,
        GameModeType.Cupcake,
    ];

    private _implementedAreas = [Area.Island, Area.Candy];

    private _implementedBooleans = [
        BooleanName.EasyModeUnlocked,
        BooleanName.CoconutBombUnlocked,
        BooleanName.FruitSmasherUnlocked,
        BooleanName.RainbowFruitUnlocked,
        BooleanName.ScoreModifierUnlocked,
        BooleanName.CupcakeModeUnlocked,
    ];

    isGameModeImplemented(gameMode: GameModeType): boolean {
        return this._implementedGameModes.includes(gameMode);
    }

    isAreaImplemented(area: Area): boolean {
        return this._implementedAreas.includes(area);
    }

    isBooleanImplemented(unlock: BooleanName): boolean {
        return this._implementedBooleans.includes(unlock);
    }
}
